interface BrandLogoProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
}

export function BrandLogo({ size = 'medium', className }: BrandLogoProps) {
  return (
    <img
      className={['brand-logo', 'brand-logo--' + size, className].filter(Boolean).join(' ')}
      src="/nns-admin-logo.png"
      alt="NNS Admin"
    />
  )
}
